export const climateRationaleSectionsMap = [
  {
    text: "Identification",
    section: "i_24",
  },
  {
    text: "Response",
    section: "r_64",
  },
  {
    text: "National Alignment",
    section: "a_84",
  },
  {
    text: "Monitoring and Evaluation",
    section: "me_100",
  },
];

export const theoryOfChangeSectionsMap = [
  {
    text: "Goal Statement Review",
    section: "GSR",
  },
  {
    text: "Log-frame Review/IRMF",
    section: "AAC",
  },
  {
    text: "Barriers and Risks Review",
    section: "BR",
  },
  {
    text: "Assumptions Validation",
    section: "A",
  },
  {
    text: "Enhanced Log-frame",
    section: "NLF",
  },
];
